import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'submit']

  connect() {
    this.searchTimerId = null
    this.toggleSubmitButton()
  }

  disconnect() {
    clearTimeout(this.searchTimerId)
  }

  scheduleSubmit() {
    clearTimeout(this.searchTimerId)
    this.toggleSubmitButton()
    this.searchTimerId = setTimeout(() => this.element.requestSubmit(), 1500)
  }

  toggleSubmitButton() {
    this.submitTarget.disabled = !this.inputTarget.value.trim()
  }
}
